// extracted by mini-css-extract-plugin
module.exports = {"wabaName":"SettingCloudAPIBusinessWaba_wabaName__3HVWL","name":"SettingCloudAPIBusinessWaba_name__205E7","selected":"SettingCloudAPIBusinessWaba_selected__3KDXG"};